<div class="page">
  <div class="password-reset-container">
    <div class="logo-section">
      <img src="{{ BASE_URL }}/web/binary/company_logo" alt="company's logo" />
      <span>{{ 'authentication.b2b_portal' | translate }}</span>
    </div>

    <form class="password-form" [formGroup]="newPasswordForm">
      <h2 class="title">{{ 'authentication.reset_password' | translate }}</h2>

      <ui-form-field data-testid="reset-new-password"
        [fullWidth]="true"
        formControlName="new_password"
        [label]="'authentication.new_password' | translate"
        [placeholder]="'authentication.enter_new_password' | translate"
        [type]="'password'"
        [errorMessages]="{
          required: 'validation.required' | translate,
          invalidPassword: 'validation.invalid_password' | translate
        }"
       />

      <ui-form-field data-testid="reset-confirm-password"
        [fullWidth]="true"
        formControlName="confirm_password"
        [label]="'authentication.confirm_password' | translate"
        [placeholder]="'authentication.confirm_password' | translate"
        [type]="'password'"
        [errorMessages]="{
          required: 'validation.required' | translate
        }"
       />

      @if (
        newPasswordForm.hasError('mismatch') &&
        (newPasswordForm.get('confirm_password')?.touched ||
          newPasswordForm.get('confirm_password')?.dirty)
      ) {
        <div class="form-error">
          <small>
            {{
              'validation.mismatch'
                | translate
                  : {
                      first: ('authentication.new_password' | translate),
                      second: ('authentication.confirm_password' | translate)
                    }
            }}
          </small>
        </div>
      }

      <ui-button data-testid="reset-submit"
        type="primary"
        [label]="'common.save' | translate"
        [fullWidth]="true"
        (click)="resetPassword()"
       />
    </form>

    <div class="copyright-section">
      <div class="powered-by">
        <span>{{ 'common.powered_by' | translate }}</span>
        <img class="logo" src="assets/images/logo.svg" alt="volta logo" />
      </div>
      <p>{{ 'authentication.terms_ack' | translate }}</p>
      <div class="links">
        <span
          [innerHTML]="'authentication.rights_reserved' | translate: { year: currentYear }"
        ></span>
        <a href="#">{{ 'common.privacy_policy' | translate }}</a>
        <a href="#">{{ 'common.support' | translate }}</a>
      </div>
    </div>
  </div>
</div>
